export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#1D3557] text-white"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="font-display text-lg font-semibold tracking-tight">
              Apple Doctor
            </div>
            <p className="mt-1 text-sm text-white/70">
              Profesjonell Apple-reparasjon via post.
            </p>
          </div>
          <div className="text-sm text-white/60">
            © {year} Apple Doctor. Apple, iPhone, iPad, MacBook og iMac er
            varemerker tilhørende Apple Inc.
          </div>
        </div>
      </div>
    </footer>
  );
}
